import React, { useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import "./scss/main.scss";
import "react-loading-skeleton/dist/skeleton.css";
import { Spinner } from "./components/ui/loader";
import { ROUTES } from "./routes";
import { initApp } from "./utils/Init";
import "./i18n";

const App = () => {
  initApp();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(ROUTES.LOGIN);
  }, []);
  return (
    <>
      <Spinner text="taking you beyond payments.." />
    </>
  );
};

export default App;
